<!--自提点配置管理-->
<template lang="html">
    <div style="height:calc(100% - 30px);margin-top: 20px;">
		<el-card class="box-card" style="height: 100%" :body-style="{height: 'calc(100% - 100px)',overflow: 'auto'}">
			<div slot="header">自提点配置管理 ></div>
			<div>
                <el-form ref="formAuth" :model="formData" label-width="240px" size="small">
                    <div style="padding-bottom:30px">
                        <el-divider content-position="center">自提点</el-divider>
                    </div>
                    <!-- <el-form-item label="自提点给旗舰店服务费提成比例：" required style="width:40%">
                        <el-input v-model="formData['shop_profit_service_fee'].value" autocomplete="off" size="mini" placeholder="请输入自提点服务费提成比例"></el-input>
                    </el-form-item> -->
                    <!-- <el-form-item label="自提点提货提成比例：" required style="width:40%">
                        <el-input v-model="formData['shop_profit_zi_ti'].value" autocomplete="off" size="mini" placeholder="请输入自提点提货提成比例"></el-input>
                    </el-form-item> -->
                    <el-form-item label="自提点保证金金额：" required style="width:40%">
                        <el-input v-model="formData['bao_zheng_jin_zi_ti'].value" autocomplete="off" size="mini" placeholder="请输入自提点保证金金额"></el-input>
                    </el-form-item>
                    <div style="padding:30px 0">
                        <el-divider content-position="center">旗舰店</el-divider>
                    </div>
                    <!-- <el-form-item label="旗舰店服务费提成比例：" required style="width:40%">
                        <el-input v-model="formData['shop_profit_qi_jian'].value" autocomplete="off" size="mini" placeholder="请输入旗舰店服务费提成比例"></el-input>
                    </el-form-item> -->
                    <el-form-item label="旗舰店保证金金额：" required style="width:40%">
                        <el-input v-model="formData['bao_zheng_jin_qi_jian'].value" autocomplete="off" size="mini" placeholder="请输入旗舰店保证金"></el-input>
                    </el-form-item>
                </el-form>
                <el-button type="primary" size="small" style="margin:100px auto 0;display: block;width:100%" @click="submit">确定</el-button>
            </div>
		</el-card>
    </div>
</template>

<script>
export default {
    data() {
        return {
            formData: {},
        }
    },
    mounted() {
        this.getData();
    },
    methods: {
        getData() {
            this.http.post('/admin/SystemConfig/indexShop').then(response => {
                this.formData = response;
            })
        },

        submit() {
            if(!this.formData['shop_profit_service_fee'].value || !this.formData['shop_profit_zi_ti'].value || !this.formData['bao_zheng_jin_zi_ti'].value || !this.formData['shop_profit_qi_jian'].value || !this.formData['bao_zheng_jin_qi_jian']
                .value) return this.$message.error('必填项不得为空')
            this.http.post('/admin/SystemConfig/save', this.formData).then(() => {
                this.$message.success('提交成功');
            })
        }
    }
}
</script>
<style lang="less" scoped>
.el-card__body {
    height: calc(100% - 95px);
    overflow: auto;
}
</style>
